export const PRICE_TYPES = Object.freeze({
  adult: "adult",
  child: "child",
  senior: "senior",
  // Tarifa del servicio completo, para las experiencias que se cobran por
  // salida y no por pasajero. Sigue la misma convención `${rate}Price` que las
  // demás, pero no es un tipo de pasajero: ver PARTICIPANT_RATES.
  service: "service",
});

// Los tipos de pasajero que se pueden cargar al comprar. Es una lista explícita
// y no las claves de `price` a propósito: derivarlas del objeto de precio hacía
// aparecer `service` como si fuera una categoría de pasajero más.
export const PARTICIPANT_RATES = Object.freeze([
  PRICE_TYPES.adult,
  PRICE_TYPES.child,
  PRICE_TYPES.senior,
]);

export const PRICE_MODES = Object.freeze({
  // Se cobra una tarifa por cada pasajero (comportamiento histórico).
  perPerson: "perPerson",
  // Se cobra un monto fijo por la salida, sin importar cuántos van.
  perService: "perService",
});

// Cuántos lugares del turno consume una reserva. Espeja
// `helpers/experiences/capacity/constants.js` del back.
export const CAPACITY_USAGE_MODES = Object.freeze({
  // Un lugar por pasajero (comportamiento histórico).
  perPerson: "perPerson",
  // La reserva toma el turno entero: nadie más puede sumarse, sin importar
  // cuántos pasajeros vayan. Es la salida privada.
  wholeSlot: "wholeSlot",
  // Consume una cantidad fija de lugares, independiente del pax.
  fixedUnits: "fixedUnits",
});

export const EXPERIENCE_DURATION = Object.freeze({
  PER_DAY: "perDay",
  PER_ACTIVITY: "perActivity",
});

export const BANNER_PAGE = Object.freeze({
  formScreen: "formScreen",
  checkInPageToProducts: "checkInPageToProducts",
  experienceScreen: "experienceScreen",
  homePage: "homePage",
  paymentScreen: "paymentScreen",
  productsScreen: "productsScreen",
  sizeScreen: "sizeScreen",
  passengersScreen: "passengersScreen",
  detailExperienceScreen: "detailExperienceScreen",
});
